import React, { FC } from "react";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { Link } from "@app/components/common";
import { PostSummary } from "@app/models";
import { useFormatDate } from "@app/hooks";
import { useBlogCategories } from "@app/hooks";

type Props = {
  className?: string;
  imageClassName?: string;
} & PostSummary;

export const ArticlePreviewCard: FC<Props> = ({
  image,
  date,
  title,
  categoryId,
  slug,
  className,
  imageClassName,
}) => {
  const formattedDate = useFormatDate(date);
  const categoriesList = useBlogCategories();
  const category = categoriesList.find(
    (category) => category.uuid === categoryId,
  );

  return (
    <div className={classNames("w-full", className)}>
      <Link to={`/blog/${categoryId}/${slug}`}>
        <GatsbyImage
          image={getGatsbyImage(image, { layout: "fullWidth" })}
          alt={title}
          className={twMerge(
            classNames(
              "xxl:aspect-[3/2] aspect-[3/2] rounded-lg",
              imageClassName,
            ),
          )}
        />
      </Link>
      <div
        className={classNames(
          "text-regular text-base-400 mt-6 mb-2.5",
          "xxl:mt-7.5",
        )}
      >
        {formattedDate}
      </div>
      <Link to={`/blog/${categoryId}/${slug}`}>
        <h4 className="text-medium text-primary-content hover:text-neutral-content duration-300">
          {title}
        </h4>
      </Link>
      {category && (
        <div
          className={classNames(
            "bg-dark text-base-400 mt-5 w-fit rounded-xs px-4 py-0.5",
          )}
        >
          {category.name}
        </div>
      )}
    </div>
  );
};
